import { Button } from '@journ/ui/button'
import { Icons } from '@journ/ui/icons'
import { memo } from 'react'
import type { Node, NodeProps } from '@/libs/workflow-node-ui'
import type { WorkflowInfoNodeData } from '../application/workflow-canvas-layout'
import { useWorkflowEditorParams } from './use-workflow-editor-params'

type WorkflowInfoNodeProps = NodeProps<Node<WorkflowInfoNodeData>>

const WorkflowInfoNode = memo(({ data }: WorkflowInfoNodeProps) => {
	const { setParams } = useWorkflowEditorParams()

	return (
		<div className='flex items-start justify-between gap-3 min-w-64 max-w-96 border border-border bg-background shadow-sm px-4 py-3'>
			<div className='min-w-0'>
				<p className='font-semibold text-sm leading-tight truncate'>{data.name}</p>
				{data.description && <p className='text-xs text-muted-foreground mt-1 line-clamp-2'>{data.description}</p>}
			</div>
			<Button
				variant='ghost'
				size='icon'
				className='size-6 shrink-0 text-muted-foreground hover:text-foreground hover:bg-muted/40 nodrag nopan'
				onClick={e => {
					e.stopPropagation()
					setParams({ editWorkflowInfo: true })
				}}
			>
				<Icons.Edit className='size-3.5' />
			</Button>
		</div>
	)
})

WorkflowInfoNode.displayName = 'WorkflowInfoNode'

export { WorkflowInfoNode }
